import React from 'react';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { Checkbox } from '@domain-group/fe-blueprint-ui/form';
import { AverageStarRatingAndTotal } from '@domain-group/fe-co-allhomes-average-star-rating-and-total';
import * as styles from './agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AgentCard = _ref => {
  var _agency$images$tinyLo, _agency$images, _agent$profilePhoto, _address$division, _address$state;
  var type = _ref.type,
    agencyProp = _ref.agency,
    agent = _ref.agent,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? true : _ref$checked,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  var isAgency = type === 'AGENCY';
  var agency = isAgency ? agencyProp : agent.agency;
  var reviewProfile = (isAgency ? agencyProp : agent).reviewProfile;
  var address = agency.address;
  return ___EmotionJSX("div", {
    css: styles.container,
    onClick: onClick,
    onKeyUp: onClick
  }, isAgency ? ___EmotionJSX("img", {
    css: styles.logo,
    src: (_agency$images$tinyLo = (_agency$images = agency.images) === null || _agency$images === void 0 ? void 0 : _agency$images.tinyLogo) !== null && _agency$images$tinyLo !== void 0 ? _agency$images$tinyLo : undefined,
    alt: ""
  }) : ___EmotionJSX("div", {
    css: styles.agent
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: (_agent$profilePhoto = agent === null || agent === void 0 ? void 0 : agent.profilePhoto) !== null && _agent$profilePhoto !== void 0 ? _agent$profilePhoto : undefined,
    size: "custom",
    colorScheme: "dark",
    shape: "circle"
  }), ___EmotionJSX("div", {
    css: styles.nameTitle
  }, ___EmotionJSX("div", {
    css: styles.agentName
  }, agent === null || agent === void 0 ? void 0 : agent.name), ___EmotionJSX("div", {
    css: styles.jobTitle
  }, agent === null || agent === void 0 ? void 0 : agent.jobTitle))), ___EmotionJSX("div", {
    css: styles.reviews
  }, reviewProfile !== null && reviewProfile !== void 0 && reviewProfile.overallRating && reviewProfile.reviewCount ? ___EmotionJSX(AverageStarRatingAndTotal, {
    size: "xs",
    averageRating: reviewProfile === null || reviewProfile === void 0 ? void 0 : reviewProfile.overallRating,
    totalReviews: reviewProfile === null || reviewProfile === void 0 ? void 0 : reviewProfile.reviewCount
  }) : null), ___EmotionJSX("div", {
    css: styles.bottom
  }, ___EmotionJSX(Checkbox, {
    checked: checked,
    onChange: onClick
  }), ___EmotionJSX("div", {
    css: styles.nameAddress
  }, ___EmotionJSX("div", {
    css: styles.agencyName
  }, agency.name), ___EmotionJSX("div", {
    css: styles.address
  }, address === null || address === void 0 ? void 0 : (_address$division = address.division) === null || _address$division === void 0 ? void 0 : _address$division.name, " ", address === null || address === void 0 ? void 0 : (_address$state = address.state) === null || _address$state === void 0 ? void 0 : _address$state.abbreviation, ' ', address === null || address === void 0 ? void 0 : address.postcode))));
};